import type { GetInventoryTransactionsQuery } from "~/gql/queries/inventoryTransactions.generated";
import type { BatchView } from "~/helpers/inventoryBatches";
import type { CachedTransaction } from "~/store/availabilitySlice";

export type InventoryTransactionNode = NonNullable<
	NonNullable<GetInventoryTransactionsQuery["inventoryTransactions"]>["nodes"]
>[number];

type BatchMovementNode = InventoryTransactionNode["batchMovements"][number];

const toCachedBatchMovements = (movements: null | readonly BatchMovementNode[] | undefined): BatchView[] =>
	(movements ?? []).map((movement) => ({
		ageDate: movement.ageDate ?? null,
		code: movement.code,
		quantity: movement.quantity,
		sourceKind: movement.sourceKind
	}));

const mapInventoryTransactionsToCache = (nodes: readonly InventoryTransactionNode[]): CachedTransaction[] =>
	nodes.map((transaction) => ({
		batchMovements: toCachedBatchMovements(transaction.batchMovements),
		grade: transaction.grade,
		id: transaction.id,
		itemName: transaction.itemName,
		locationName: transaction.locationName,
		previousQuantity: transaction.previousQuantity,
		quantity: transaction.quantity,
		reasonCode: transaction.reasonCode ?? undefined,
		sku: transaction.sku,
		timestamp: transaction.timestamp,
		transactionType: transaction.transactionType,
		userId: transaction.userId,
		why: transaction.why
	}));

export default mapInventoryTransactionsToCache;
